module.exports = __webpack_public_path__ + "img/ability-lab.41d6c4d7.svg";